<div #pagetop class="card shadow mb-4">
    <div class="card-header py-3">
        <div class="row">
            <h5 *ngIf="!isEditForm" class="col-9 m-0 font-weight-bold text-primary">
                {{ 'add-specialisation' | translate }}
            </h5>
            <h5 *ngIf="isEditForm" class="col-9 m-0 font-weight-bold text-primary">
                {{ 'edit-specialisation' | translate }}
            </h5>
        </div>
    </div>
    <div *ngIf="speciality" class="card-body">
        <form #form2="ngForm" autocomplete="off">
            
            <div class="form-group">
                <div class="input-group">
                    *<div class="font-weight-bold">{{ 'speciality-name' | translate }}</div>
                </div>
                <div class="input-group">
                    <input name="name" #name="ngModel" [(ngModel)]="speciality.name"
                    (keydown.enter)="onEnterPress($event,form2.invalid)" class="form-control" required>
                </div>
                <div *ngIf="name.invalid && (name.dirty || name.touched)" class="text-danger mx-2 my-1">
                    <div *ngIf="name.errors.required">{{ 'speciality-name-required' | translate }}</div>
                </div>
            </div>

            <div class="form-group row">
                <button class="btn btn-danger m-1" (click)="router.navigate(['workSchedule'])">{{ 'back' | translate }}</button>
                <button class="btn btn-primary m-1" type="submit" [disabled]="formSubmitted || form2.invalid"
                 (click)="onSubmit()">
                <span *ngIf="formSubmitted" class="spinner-border spinner-border-sm my-1" role="status"
                    aria-hidden="true"></span>{{ 'save-speciality' | translate }}
                </button>
            </div>
        </form>
    </div>
</div>

